<div>
    <div class="flex flex-column rounded shadow-sm px-4 py-2 bg-white">
        <div class="text-lg font-semibold">
            {{ pageTitle }}
        </div>
        <app-breadcrumb ></app-breadcrumb>
    </div>
</div>
<div class="mt-3">
    <div class="card border-0 shadow-sm ">
        <div class="card-body px-4">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>